import Vue from 'vue';

import clerk, { isClerkReady } from '@/lib/clerk';

const ClerkPlugin = {
  install(VueInstance: typeof Vue) {
    window.Clerk = clerk;
    VueInstance.prototype.$clerk = clerk;
    VueInstance.prototype.$isClerkReady = isClerkReady;
  },
};

Vue.use(ClerkPlugin);
